import { useCurrentScenarioWithContentHeader } from '../lib/useCurrentScenarioWithContentHeader';
import type { NavigationHeaderCommonProps } from '../types';

import { NavigationHeader } from './NavigationHeader';

export const NavigationHeaderContainer = (props: NavigationHeaderCommonProps) => {
  const scenario = useCurrentScenarioWithContentHeader();

  if (!scenario) {
    return null;
  }

  return (
    <NavigationHeader
      {...props}
      scenario={scenario}
    />
  );
};
